import { ButtonInputWithPopover, SelectMultiple } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { OrderStatus } from "../../../../clients/graphqlTypes.js";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { FilterProps } from "../../../commons/filters/index.js";
import { usePurchaseOrderStatus } from "../usePurchaseOrderStatus.js";

export function PurchaseOrderStatusFilterButton(
  props: FilterProps<OrderStatus[]>
) {
  const { t } = useTranslate(["Global"]);
  const { statusOptions } = usePurchaseOrderStatus();

  return (
    <ButtonInputWithPopover
      label={t("Status", {
        ns: "Global",
      })}
      counter={
        props.value &&
        props.value.length > 0 &&
        props.value.length < statusOptions.length
          ? props.value.length
          : undefined
      }
      content={<PurchaseOrderStatusFilterForm {...props} />}
      popoverWidth="md"
    />
  );
}

function PurchaseOrderStatusFilterForm({
  value,
  setValue,
}: FilterProps<OrderStatus[]>) {
  const { statusOptions } = usePurchaseOrderStatus();

  return (
    <Box
      sx={{
        p: 1,
      }}
    >
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          {statusOptions.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={value.includes(option.value)}
                  onChange={(_event, checked) => {
                    if (checked) {
                      setValue(Array.from(new Set([...value, option.value])));
                    } else {
                      setValue(value.filter(v => v !== option.value));
                    }
                  }}
                />
              }
              label={<Typography variant="body1">{option.label}</Typography>}
              sx={{ ml: 0, mr: 0 }}
              key={`${option.value}-${index}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export function PurchaseOrderStatusSelect({
  value,
  setValue,
  ...props
}: FilterProps<OrderStatus[]>) {
  const { t } = useTranslate("Global");
  const { statusOptions } = usePurchaseOrderStatus();

  return (
    <SelectMultiple
      label={t("Status", {
        ns: "Global",
      })}
      options={statusOptions}
      value={Array.isArray(value) ? value : [value]}
      onChange={setValue}
      {...props}
    />
  );
}

export function PurchaseOrderStatusFilterChips(
  props: Omit<FilterChipGroupProps<OrderStatus>, "label" | "getValueLabel">
) {
  const { t } = useTranslate("Global");
  const { statusLabels } = usePurchaseOrderStatus();

  return (
    <FilterChipGroup
      label={t("Status", {
        ns: "Global",
      })}
      setValues={props.setValues}
      values={props.values}
      getValueLabel={value => statusLabels[value]}
    />
  );
}
